export default {
    primary: '#0C0030',
    secondary: '#EDEAFB', 
    tertiary: '#181818', 
    quaternary: '#0C1974',
    transparent: 'rgba(0,0,0,0)',
    overlay: 'rgba(0,0,0,0.3)'
}